// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S4Lz","footer":"styles_footer__1UlUV"};